import { useState, useEffect, Fragment } from "react";
import {
  useParams,
  useNavigate,
  Link,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";

import { ReactSession } from "react-client-session";
import SidebarCss from "./sidebar.module.css";

import Loading from "../Loading";
import Support from "../../Dashboard/Support";
import Billings from "../../Dashboard/Billings";
import Resources from "../../Dashboard/Resources";
import Overview from "../../Dashboard/Overview";
import APIUsage from "../../Dashboard/APIUsage";
import PricingPage from "../../Dashboard/Pricing";
import Grpcs from "../../Dashboard/Grpcs";
import DedicatedNodes from "../../Dashboard/DedicatedNodes";

import NavBarUser from "../Header/Header2";
import CardAdd from "../../Dashboard/CardAdd";
import Credits from "../../Dashboard/Credits";
import Cardprofile from "../../Dashboard/CardProfile";
import SuccessNoti from "../../Dashboard/SuccessNoti";
// import NftClaimOffer from "../../Dashboard/NftClaimOffer";
import NftNoClaim from "../../Dashboard/NftNoClaim";
import SuccessOfferClaim from "../../Dashboard/SuccessOfferClaim";
import EligibleLoading from "../../Dashboard/EligibleLoading";
import SidebarWithHeader from "./SidebarWithHeader";
import ErrorOccured from "../../Dashboard/ErrorInClaim";
import JupApi from "../../Dashboard/JupApi";
import IntercomComponent from "../IntercomIntegration/IntercomComponent";
import ImportantNotice from "../../Dashboard/ImportantNotice";
import SupportHiglighter from "../../Dashboard/SupportHighlighter";

import { Box, Flex, Text } from "@chakra-ui/react";
import Rpcs from "../../Dashboard/Rpcs";
import Onboarding from "../../Dashboard/Onboarding";
import Rabbitstream from "../../Dashboard/Rabbitstream";
import Referrals from "../../Dashboard/Referral";
import ProductInterestComponent from "../../Dashboard/ProductInterestCard";

const availableModules = [ "overview", "api_usage", "resources", "pricing", "credits", "billings", "support", "grpc", "rabbitstream", "referrals", "select-plan", "user-details"];

// Token for which the subscription sync was already attempted. Lives at module
// scope so a Sidebar remount (e.g. /pricing -> back) doesn't sync again.
let subscriptionSyncedForToken = null;

const Sidebar = () => {
  const navigate = useNavigate();
  const { module } = useParams();
  const rewardSysActive = process.env.REACT_APP_REWARD_SYSTEM ?? "inactive";

  let [searchParams, setSearchParams] = useSearchParams();
  const paymentStatus = searchParams.get("success") ?? "unknown";
  const [apKey, setApKey] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  // const [page,setPage] = useState(0);
  const [plan, setPlan] = useState("");
  const [planName, setPlanName] = useState("");
  const [showCard, setShowCard] = useState(false);
  // const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

  // const [isOpen, setOpen] = useState(true);
  const [isLoadingData, setLoadingData] = useState(true);
  const [loadedTopBar, setLoadedTopBar] = useState(false);
  const [isFreeUser, setFreeUser] = useState(false);
  const [currentPlan, setCurrentPlan] = useState("");

  const [grpcPaymentInfoPresent,setGRPCPaymentInfoPresent] = useState(false);
  

  const [showDetailsCard, setShowDetailsCard] = useState(false);

  const [paymentPopup, setPaymentPopup] = useState(false);
  const [payMessage, setPaymentMessage] = useState(false);

  const [planDetails, setPlanDetails] = useState([]);
  const [offersLoading, setOffersLoading] = useState("unloaded");
  const [showPlanCard, setShowPlanCard] = useState(false);

  const [currentOfferLoad, setOfferLoad] = useState("unloaded");
  const [currentOffer, setCurrentOffer] = useState(null);
  const [noApplicable, setApplicable] = useState(false);

  const [claimedOffer, setClaimedOffer] = useState(false);

  const [isWalletConnected, setWalletConnected] = useState(false);
 

  const [readyToLoadChat, setReadytoLoadChat] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [showSupportText, setShowSupportText] = useState(false);

  const [refBillingAmount, setReferralBillingAmount] = useState(0);
  const [apiKeyRoated,setApiKeyRotated] = useState(false);
  const [createdAt,setCreatedAt] = useState(null);

  const [hardCheckSubscription, setHardCheckSubscriptions] = useState(false);
  // Bumped once after a successful subscription sync to re-mount the active page so it re-fetches its plan data
  const [planRefreshKey, setPlanRefreshKey] = useState(0);

  const [combinedPlanName, setCombinedPlanName] = useState("FREE");

  const [showSurveyForm,setShowSurveyForm] = useState(false);


  const displaySupportTextforSecs = (secs) => {
    setShowSupportText(true);
    setTimeout(() => {
      setShowSupportText(false);
    }, secs * 1000);
  }

  // const userWallet = useWallet();
  // const setPlanAndShowCard = (plan) => {
  //     setPlan(plan);
  //     setShowCard(true);
  // }
  useEffect(() => {
    //console.log(paymentStatus);
    //console.log(typeof paymentStatus);
    if (paymentStatus === "true") {
      setPaymentMessage(true);
      if(module === "overview") {
        setShowSurveyForm(true);
      } else {
        setPaymentPopup(true);
      }
      try {
        window?.datafast("purchase_successful");
      } catch (error) {
        console.log(error);
      }
    } else if (paymentStatus === "false") {
      setPaymentMessage(false);
      setPaymentPopup(true);
    }
    setTimeout(() => {
      setPaymentPopup(false);
    }, 3000);
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "auto",
    });
    setLoadingData(true);
    // if (window.innerWidth < 767) {
    //     document.getElementById("menu").style.opacity = "0.0";
    //     document.getElementById("mySidenav").style.width = "0";
    //     setOpen(true);
    // }
  }, [module]);

  useEffect(() => {
    if(!availableModules.includes(module)) {
        ReactSession.set("xTkn", "");  
        setReadytoLoadChat(false);
        navigate("/get-api-key");
    }

    const token = ReactSession.get("xTkn") ?? "";
    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      let rqUrl = `${endPoint}auth/profile`;

      axios({
        // Endpoint to get NFTs
        url: rqUrl,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
      })
        // Handle the response from backend here
        .then((res) => {
          setLoadedTopBar(true);
          //console.log(res.data);
          if (res.data.success === true) {
            setApKey(res.data.result?.api_key);
            setEmail(res.data.result?.email);
            try{
              const refreshedAt = res.data.result?.last_refreshed_at;
              const createdAt = res.data.result?.created_at;
              // Users must have created or refreshed their API key on/after 2026-10-20, else they're prompted to rotate.
              const cutoffDate = new Date("2026-10-20T00:00:00.000Z");

              const createdAfterCutOff = createdAt && new Date(createdAt) >= cutoffDate;
              const refreshedAfterCutoff = refreshedAt && new Date(refreshedAt) >= cutoffDate;

              setApiKeyRotated(Boolean(createdAfterCutOff || refreshedAfterCutoff));
              setCreatedAt(createdAt);
            } catch (error) {
              console.log("Could not get refresh times.");
            }
            try {
              if (paymentStatus === "true") {
                window.datafast("payment", { email: res.data.result?.email });
              }
            } catch (error) {
              console.log("Cannot push payment to datafast.");
            }
            try {
              setName(res.data.result?.name);
            } catch (error) {
              setName("");
            }
            if (!res.data.result?.name) {
              try {
                const detailsCheckTime = ReactSession.get("detCheckTime");
                const dateNow = new Date();
                const dateChecked = new Date(detailsCheckTime);
                if (
                  dateNow.getUTCDate() != dateChecked.getUTCDate() ||
                  dateNow.getUTCMonth() != dateChecked.getUTCMonth() ||
                  dateNow.getUTCFullYear() != dateChecked.getUTCFullYear()
                ) {
                  //show modal for details
                  setShowDetailsCard(true);
                }
              } catch (err) {
                console.error(err);
              }
            }
          } else {
            //remove Token
            ReactSession.set("xTkn", "");
            navigate("/get-api-key");
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          ReactSession.set("xTkn", "");
          setLoadedTopBar(false);
          navigate("/get-api-key");
        });
    } else {
      if ((module === "select-plan" || module === "pricing") && searchParams.get("onboarding") === "true") {
        ReactSession.set("lastNavigate", "onboard");
      }
      ReactSession.set("xTkn", "");
      setReadytoLoadChat(false);
      // navigate("/get-api-key");
    }
  }, []);

  const fetchActivePlans = () => {
    const token = ReactSession.get("xTkn") ?? "";

    if (token !== "") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      axios({
        url: `${endPoint}dashboard/get_active_plans`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.data.success === true) {
            
            const gRPCPlanPresent = res.data.result.find(plan => plan.plan_name === "GRPC");
            setGRPCPaymentInfoPresent(gRPCPlanPresent !== undefined);

            const multiMonthPlans = ["HACK", "LAUNCH", "SCALE", "BUILD", "GROW", "ACCELERATE"];
            const activePlan = res.data.result.find(plan => multiMonthPlans.includes(plan.plan_name?.toUpperCase()));
            if (activePlan) {
              const suffix = activePlan.billing_interval === 6 ? "s" : activePlan.billing_interval === 3 ? "q" : "";
              setCombinedPlanName(activePlan.plan_name?.toLowerCase() + suffix);
            }

            // Sync only when returning from checkout (?success=true), and only
            // once; after a sync the plans are re-fetched, so an empty result
            // there must not trigger another sync.
            if(paymentStatus === "true" && res.data.result.length === 0 && subscriptionSyncedForToken !== token) {
              subscriptionSyncedForToken = token;
              setHardCheckSubscriptions(true);
            }
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);

        });
    }
  };

  useEffect(() => {
    fetchActivePlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    ReactSession.set("xTkn", "");
    setReadytoLoadChat(false);
    navigate("/get-api-key");
  };

  // useEffect(() => {
  //   if (userWallet.publicKey && connectWalletClicked === true) {
  //     // console.log("Pathname where connectWallet runs", window.location.pathname)
  //     if (window.location.pathname === "/dashboard/overview")
  //       connectWallet(userWallet.publicKey?.toBase58());
  //     setWalletConnected(true);
  //   } else setWalletConnected(false);
  // }, []);

  //fix for when wallet connected on login
  // const connectClick = () => {
  //   if(userWallet.publicKey)
  //     setWalletClicked(false);
  //   else
  //     setWalletClicked(true)
  // }

  const connectWallet = async (walletAddress) => {
    const token = ReactSession.get("xTkn") ?? "";
    const rewardSysActive = process.env.REACT_APP_REWARD_SYSTEM ?? "inactive";

    if (token !== "" && rewardSysActive === "active") {
      const endPoint = process.env.REACT_APP_AUTH_EP;
      let rqUrl = `${endPoint}dashboard/reward/eligible`;
      setOffersLoading("loading");
      axios({
        // Endpoint to get NFTs
        url: rqUrl,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "ngrok-skip-browser-warning": "69420",
        },
        params: {
          address: walletAddress,
        },
      })
        // Handle the response from backend here
        .then((res) => {
          setOffersLoading("loaded");
          //console.log(res.data);
          if (res.data.success === true) {
            setPlanDetails(res.data.result ?? []);
            if (res.data.result?.length === 0) setApplicable(true);
          }
        })
        // Catch errors if any
        .catch((err) => {
          console.warn(err);
          //ReactSession.set("xTkn", "");
          setOffersLoading("error");
          setTimeout(() => {
            setOffersLoading("unloaded");
          }, 1000);
          //navigate("/get-api-key");
        });
    } else {
      ReactSession.set("xTkn", "");
      navigate("/get-api-key");
    }
  };

  useEffect(() => {
    if (email !== "" && apKey !== "") {
      setReadytoLoadChat(true);
    }
  }, [email, apKey]);

  useEffect(() => {
    const token = ReactSession.get("xTkn") ?? "";
    if(hardCheckSubscription === true && token !== "")
    {
        const endPoint = process.env.REACT_APP_AUTH_EP;
        let rqUrl = `${endPoint}dashboard/sync_subscriptions`;
        axios({
          url: rqUrl,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "69420",
          },
        })
          // Handle the response from backend here
          .then((res) => {
            setHardCheckSubscriptions(false);
            if (res.data.success === true) {
              // Soft refresh: re-fetch plans and re-mount the active page
              // (once, guarded by the sync guard) instead of reloading
              fetchActivePlans();
              setPlanRefreshKey((k) => k + 1);
            }
          })
          // Catch errors if any
          .catch((err) => {
            console.warn(err);
            setHardCheckSubscriptions(false);
          });
    }
  },[hardCheckSubscription])

  

  return (
    <>
      <Loading isLoadingData={isLoadingData} />
      <Box bg={"brand.slate"} pt={1} pb={2} position={"fixed"} w={"100%"} zIndex={999}>
      
        <Flex justifyContent={"center"}>
          <Box px={4} pt={"2px"}>
            <Text as="div" textColor={"brand.black"} pt={"2px"} fontWeight={"500"} color={"brand.lighterWhite"} fontSize={{base:"xs", md:"md"}}> <Box as="span" color={"brand.yellow"}>Important!</Box> Following a potential exposure of our logging infra, we are advising everyone to rotate their <b style={{textDecoration: "underline dotted", textUnderlineOffset: "3px"}}>API key</b> and <b style={{textDecoration: "underline dotted", textUnderlineOffset: "3px"}}>gRPC token</b> at the earliest.</Text>
          </Box>    
        </Flex>
      </Box>

      <div className={SidebarCss.dark_backdrop_gradient} data-hj-suppress data-clarity-mask="true">
        {paymentPopup && <SuccessNoti payMessage={payMessage} />}
        {showSurveyForm && <ProductInterestComponent showSurveyForm={showSurveyForm} setShowSurveyForm={setShowSurveyForm} />}
        {showCard && (
          <CardAdd
            setShowCard={setShowCard}
            setFreeUser={setFreeUser}
            plan={plan}
            planName={planName}
            setCurrentPlan={setCurrentPlan}
            email={email ?? "unknown"}
          />
        )}

        {/* {showPlanCard && (
          <NftClaimOffer
            setShowPlanCard={setShowPlanCard}
            planDetails={planDetails}
            setPlanDetails={setPlanDetails}
            setCurrentOffer={setCurrentOffer}
            setClaimedOffer={setClaimedOffer}
          />
        )} */}
        {noApplicable && (
          <NftNoClaim navigate={navigate} setApplicable={setApplicable} />
        )}
        {/* {showDetailsCard && (
          <Cardprofile setShowDetailsCard={setShowDetailsCard} />
        )} */}
        {showDisclaimer && <ImportantNotice setShowDisclaimer={setShowDisclaimer} navigate={navigate} />}
        {showSupportText && <SupportHiglighter />}
        {claimedOffer && <SuccessOfferClaim />}
        {offersLoading === "error" && <ErrorOccured />}
        {offersLoading === "loading" && <EligibleLoading />}
        {/* <EligibleLoading /> */}
        {module !== "select-plan" && <SidebarWithHeader
          path={module}
          email={email}
          name={name}
          apKey={apKey}
          logout={logout}
          displaySupportTextforSecs={displaySupportTextforSecs}
        >
          <div>
            {readyToLoadChat && <IntercomComponent userId={apKey} username={name ?? email.split("@")[0]} useremail={email} />}
            <Fragment key={planRefreshKey}>
            {module === "overview" ? (
              <Overview
                setShowCard={setShowCard}
                setLoading={setLoadingData}
                isLoading={isLoadingData}
                currentPlan={currentPlan}
                setCurrentPlan={setCurrentPlan}
                offersLoading={offersLoading}
                planDetails={planDetails}
                currentOfferLoad={currentOfferLoad}
                setOfferLoad={setOfferLoad}
                currentOffer={currentOffer}
                setCurrentOffer={setCurrentOffer}
                isWalletConnected={isWalletConnected}
                setShowPlanCard={setShowPlanCard}
                apiKeyRoated={apiKeyRoated}
                setGRPCPaymentInfoPresent={setGRPCPaymentInfoPresent}
                setReferralBillingAmount={setReferralBillingAmount}
              />
            ) : (
              ""
            )}
            {module === "api_usage" ? (
              <APIUsage setLoading={setLoadingData} isLoading={isLoadingData} />
            ) : (
              ""
            )}
            {module === "resources" ? (
              <Resources
                setLoading={setLoadingData}
                isLoading={isLoadingData}
              />
            ) : (
              ""
            )}
            {module === "pricing" ? (
              <PricingPage
                setShowCard={setShowCard}
                setLoading={setLoadingData}
                isLoading={isLoadingData}
                isFreeUser={isFreeUser}
                setFreeUser={setFreeUser}
                currentPlan={currentPlan}
                setCurrentPlan={setCurrentPlan}
                plan={plan}
                setPlan={setPlan}
                planName={planName}
                setPlanName={setPlanName}
                currentOffer={currentOffer}
                setApplicable={setApplicable}
                grpcPaymentInfoPresent={grpcPaymentInfoPresent}
                combinedPlanName={combinedPlanName}
              />
            ) : (
              ""
            )}
            {module === "credits" ? (
              <Credits setLoading={setLoadingData} isLoading={isLoadingData} />
            ) : (
              ""
            )}
            {module === "billings" ? (
              <Billings
                setLoading={setLoadingData}
                isLoading={isLoadingData}
                email={email}
                setShowCard={setShowCard}
                isFreeUser={isFreeUser}
                setFreeUser={setFreeUser}
                currentPlan={currentPlan}
                setCurrentPlan={setCurrentPlan}
              />
            ) : (
              ""
            )}
            {module === "support" ? (
              <Support setLoading={setLoadingData} isLoading={isLoadingData} />
            ) : (
              ""
            )}
            {module === "grpc" ? (
              <Grpcs 
                setLoading={setLoadingData} 
                isLoading={isLoadingData}
                setShowCard={setShowCard}
                plan={plan}
                setPlan={setPlan}
                planName={planName}
                setPlanName={setPlanName}
                navigate={navigate}
              />
            ) : (
              ""
            )}
            {module === "rabbitstream" ? (
              <Rabbitstream 
                setLoading={setLoadingData} 
                isLoading={isLoadingData}
                setShowCard={setShowCard}
                plan={plan}
                setPlan={setPlan}
                planName={planName}
                setPlanName={setPlanName}
                navigate={navigate}
              />
            ) : (
              ""
            )}
            {module === "rpc" ? (
              <Rpcs
                setLoading={setLoadingData} 
                isLoading={isLoadingData}
                setShowCard={setShowCard}
                plan={plan}
                setPlan={setPlan}
                planName={planName}
                setPlanName={setPlanName}
                navigate={navigate}
              />
            ) : (
              ""
            )}
            {module === "dedicated-nodes" ? (
              <DedicatedNodes 
                setLoading={setLoadingData} 
                isLoading={isLoadingData}
                setShowCard={setShowCard}
                plan={plan}
                setPlan={setPlan}
                planName={planName}
                setPlanName={setPlanName}
                navigate={navigate}
              />
            ) : (
              ""
            )}
            {
              module === "referrals" ? 
                (<Referrals 
                  setLoading={setLoadingData} 
                  isLoading={isLoadingData} 
                  currentPlan={currentPlan}
                  refBillingAmount={refBillingAmount} 
                />) : (
                ""
              )
            }
            {/* {module === "jup_api" ? (
              
              <JupApi 
                setLoading={setLoadingData} 
                isLoading={isLoadingData}
                setShowCard={setShowCard}
                plan={plan}
                setPlan={setPlan}
                planName={planName}
                setPlanName={setPlanName}
                navigate={navigate}
              />
            ) : (
              ""
            )} */}
            </Fragment>
          </div>
        </SidebarWithHeader>}
        {module === "select-plan" ? (
          <Onboarding 
            key={planRefreshKey}
            setShowCard={setShowCard}
            setLoading={setLoadingData}
            isLoading={isLoadingData}
            isFreeUser={isFreeUser}
            setFreeUser={setFreeUser}
            currentPlan={currentPlan}
            setCurrentPlan={setCurrentPlan}
            plan={plan}
            setPlan={setPlan}
            planName={planName}
            setPlanName={setPlanName}
            currentOffer={currentOffer}
            setApplicable={setApplicable}
            grpcPaymentInfoPresent={grpcPaymentInfoPresent}
            readyToLoadChat={readyToLoadChat}
            apKey={apKey} 
            username={name ?? email.split("@")[0]} 
            useremail={email}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default Sidebar;
